import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { fetchSubscriptionCoupons } from "./subscriptionCoupons.thunk";

const subscriptionCouponsSlice = createSlice({
  name: "subscriptionCoupons",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionCoupons.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionCoupons.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(fetchSubscriptionCoupons.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.meta.aborted
          ? null
          : "Failed to fetch subscription coupons";
      });
  },
});

export default subscriptionCouponsSlice.reducer;
